import BaseService from '../BaseService'
import axios from "axios";

class FeedbackService extends BaseService {
    constructor() {
        super('/feedback');
    }

    removal ({ payload }) {
        return axios.post(`${this.resource}/removal`, payload)
    }

    getFeedbackDaily () {
        return axios.get(`${this.resource}/daily-counts`)
    }
}

export default new FeedbackService()
